<template>
    <div class="page-wrapper">
      <search-list @findData="findData" ></search-list>
      <div >
      <table-list
        title=""
        :columns="columns"
        :current="current"
        :data="dataTable"
        :total="total"
        :loading="loading"
        @change-page="changPage"

      >
      </table-list>
      </div>

      <close-remind :n="closeKey" :remindFid="closeRemindFid" :remindStatus="remindStatus" @refresh="findData(searchData)"></close-remind>
      <create-business-modal
        :enumList="enumList"
        :projectList="projectList"
        :clientTypeList="clientTypeList"
        :projectFid = "projectFid"
        :statusList = "statusList"
        :channelList = "channelList"
        :customerPhone = "customerPhone"
        :customerName = "customerName"
        :isHouseRemind = true
        :houseTypeFid = "houseTypeFid"
        :houseRemindFid = "houseRemindFid"
        :n = "createKey"
        :budgetRangeList="budgetRangeList"
        :commutingModeList="commutingModeList"
        :intentionAreaList="intentionAreaList"
        :houseTypeList="houseTypeList"
        :liveNumberList="liveNumberList"
        :shortRentDesList="shortRentDesList"
        :gradeList="gradeList"
        @refresh="findData(searchData)"
      >
      </create-business-modal>
      <read-or-handle-modal
        :enumList="enumList"
        :uid="uid"
        :n="readOrHandleKey"
        :zoFid="zoFid"
        :clientTypeList="clientTypeList"
        :businessFid = "businessFid"
        :projectFid="projectFid"
        :statusList = "statusList"
        @refresh="findData(searchData)"
        :isRead="isRead"
        :budgetRangeList="budgetRangeList"
        :commutingModeList="commutingModeList"
        :intentionAreaList="intentionAreaList"
        :houseTypeList="houseTypeList"
        :liveNumberList="liveNumberList"
        :shortRentDesList="shortRentDesList"
        :gradeList="gradeList"
      >
      </read-or-handle-modal>
    </div>
</template>

<script type="text/ecmascript-6">

import { deepClone  } from '@/utils/format'
import {findContractInfoByCode, getList} from "api/roomRemind";
import SearchList from './components/SearchList'
import CloseRemind from './components/CloseRemind'
import TableList from 'components/TableList/index'
import CreateBusinessModal from '../readBusiness/components/CreateBusinessModal';
import ReadOrHandleModal from '../readBusiness/components/ReadOrHandle';
import { getSelectedData,getBusinessEnums} from 'api/business'
import { getProjects } from 'api/common'
export default {
  created() {
    this.getAllSelect();
  },
  computed:{
  },
  components: {
    SearchList,
    CloseRemind,
    TableList,
    CreateBusinessModal,
    ReadOrHandleModal,
  },
  data() {
    return {
      uid:'',
      current:1,
      total:0,
      createKey:0,
      projectFid:'',
      zoFid:'',
      customerPhone:'',
      customerName:'',
      businessFromChannel:'13',
      houseTypeFid:'',
      houseRemindFid:'',
      readOrHandleKey:0,
      isRead:false,
      closeKey:0,
      closeRemindFid:'',
      businessFid:'',
      remindStatus:0,
      loading:true,
      dataTable:[],
      projectList:[],
      clientTypeList:[],
      statusList:[],
      channelList:[],
      gradeList: [],
      sourceList:[],
      budgetRangeList:[],
      commutingModeList:[],
      intentionAreaList:[],
      houseTypeList:[],
      liveNumberList:[],
      shortRentDesList:[],
      enumList:null,
      searchData: {
        projectFid: '',
        houseTypeFid: '',
        remindStatus: '',
        isSignContract: '',
        customerInfo: '',
        createTimeFrom: '',
        createTimeTo: '',
        triggerReminderTimeFrom: '',
        triggerReminderTimeTo: '',
        endTimeFrom: '',
        endTimeTo: '',
        page: 1,
        limit: 10
      },
      columns:[
        {
          type:'index',
          width:60,
        },
        {
          title:' '
        },
        {
          title: '有房提醒状态',
          key: 'remindStatus',
          width:120,
          align: 'center',
          render: (h,params) => {
            return h('div',{
              'class': {
                'error-color': params.row.remindStatus == 0,
                'success-color ': params.row.remindStatus == 1,
                'disable-color':params.row.remindStatus == 2,
                'disable-color':params.row.remindStatus == 3,
                'disable-color':params.row.remindStatus == 4,
              },
            },params.row.remindStatusCn)
          }
        },
        {
          title:' '
        },
        {
          title: '客户姓名',
          key: 'customerName',
          width:100,
          align: 'center'
        },
        {
          title:' '
        },
        {
          title: '客户电话',
          key: 'customerPhone',
          align: 'center',
          width:120,
        },
        {
          title:' '
        },
        {
          title: '房型名称',
          key: 'houseTypeName',
          align: 'center',
          width:220
        },
        {
          title:' '
        },
        {
          title: '跟进人',
          key: 'zoName',
          align: 'center',
          width:180
        },
        {
          title: '关闭原因',
          key: 'closeReason',
          align: 'center',
          width:180,
          render: (h, params) => {
            if (params.row['closeReason'] && params.row['closeReason'].length > 10) {
              return h('Tooltip', {
                props: {
                  placement: "top"
                }
              }, [
                h('div', {
                  style: {
                    whiteSpace: 'normal'
                  },
                  slot: 'content',
                }, params.row['closeReason']),
                h('span', {}, params.row['closeReason'].slice(0, 10) + '...')
              ])

            }
            else {
              return h('span', {}, params.row['closeReason'])
            }
          }
        },
        {
          title:' '
        },
        {
          title: '系统触发提醒时间',
          key: 'triggerReminderTime',
          align: 'center',
          width:180
        },
        {
          title:' '
        },
        {
          title: '创建时间',
          key: 'createTime',
          align: 'center',
          width:180
        },
        {
          title:' '
        },
        {
          title: '项目名称',
          key: 'projectName',
          align: 'center',
          width:200

        },
        {
          title:' '
        },
        {
          title: "是否签约",
          key: "contractCode",
          align: "center",
          width:100,
          render: (h, params) => {
            if(params.row.isSignContract == 1){
              return h('a', {
                on: {
                  click: () => {
                    this.toContractDetail(params.row.contractSn)
                  },
                }
              }, params.row.isSignContractCn)
            }else {
              return h('span',{},params.row.isSignContractCn)
            }
          }
        },
        {
          title:' '
        },
        {
          title: '操作',
          key: 'action',
          width:150,
          fixed:'right',
          align: 'center',
          render: (h,params)=>{
            return h('div',[
              h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'business/createBusiness'
                    }
                  }
                ],
                style: {
                  marginRight: '5px',
                  display: params.row.remindStatus == 0 || params.row.remindStatus == 1 ? 'inline-block' :'none'
                },
                on:{
                  click: () => {
                      this.projectFid = params.row.projectFid
                      this.customerPhone = params.row.customerPhone
                      this.customerName = params.row.customerName
                      this.houseTypeFid = params.row.houseTypeFid
                      this.houseRemindFid = params.row.fid
                      getProjects().then( res=> {
                      this.projectList = res.data
                      getSelectedData().then( res => {
                        this.sourceList = res.data.source
                        this.channelList = res.data.channel
                        this.gradeList = res.data.grade
                        this.clientTypeList = res.data.clientType
                        this.statusList = res.data.status
                        const index = this.statusList.findIndex(item => {
                          return item.value == 0
                        })
                        if(index > -1) {
                          this.statusList.splice(index,1)
                        }
                        this.createKey++
                      })
                    })
                  }
                }
              },'转为商机'),
              h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'idelHouseRemind/closeHouseRemind'
                    }
                  }
                ],
                style: {
                  marginRight: '5px',
                  display: params.row.remindStatus==0 || params.row.remindStatus == 1 ? 'inline-block' :'none'
                },
                on:{
                  click: () => {
                    this.closeRemindFid = params.row.fid
                    this.remindStatus = params.row.remindStatus
                    this.closeKey++
                  }
                }
              },params.row.remindStatus==0?'关闭提醒':'关闭'),h('a',{
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'business/saveBusinessHandle'
                    }
                  }
                ],
                style: {
                  marginRight: '5px',
                  display: params.row.businessFid!='' && params.row.remindStatus==3 ? 'inline-block' :'none'
                },
                on:{
                  click: () => {
                    this.isRead = true
                    this.zoFid = params.row.zoId
                    this.businessFid = params.row.businessFid
                    this.projectFid = params.row.projectFid
                    getSelectedData().then( res => {
                      this.clientTypeList = res.data.clientType
                      this.statusList = res.data.status
                      this.readOrHandleKey++;
                    })
                  }
                }
              },'查看商机')])
          }
        },
      ],
    }
  },
  methods: {
    getAllSelect(){
      getBusinessEnums().
      then( res => {
        this.enumList=res.data
        this.budgetRangeList = res.data.budgetRange;
        this.commutingModeList = res.data.commutingMode;
        this.intentionAreaList = res.data.intentionArea;
        this.houseTypeList = res.data.houseType;
        const liveNumberList = res.data.liveNumber;
        for(let i = 1 ; i <= liveNumberList; i++){
          this.liveNumberList.push(i)
        }
        this.placeList = res.data.place;
        this.shortRentDesList = res.data.shortRentDes;
        this.rentTimeList = res.data.rentTime;
      })
    },
    toContractDetail(contractSn) {
      findContractInfoByCode({'contractCode': contractSn}).then( res => {
        if(!res.data){
          return
        }
        if(res.data.parentContractFid){
          const query = {
            isParent: 0,
            id: res.data.fid,
            code: res.data.contractCode,
            pid: res.data.parentContractFid,
          };
          this.$router.push({name: 'companycontractdetail', query: query})
        }else {
          this.$router.push({
            name: 'personalcontractdetail',
            query: {id: res.data.fid, code: res.data.contractCode}
          })
        }
      })
    },
    changPage(n){
      this.loading = true;
      this.current = n;
      this.searchData.page = n
      this.initTableList()
    },
    findData(searchData){
        this.loading = true;
        this.searchData = deepClone(searchData)
        this.initTableList()
    },
    initTableList(){
      getList(this.searchData).then(res=>{
        if(!res.data){
          this.loading = false;
          return
        }
        this.dataTable=res.data.rows;
        this.total=res.data.total;
        this.loading = false;
      }).catch(error=>{})
    },
  }
};
</script>

<style lang="css" scoped>
.btn {
  margin-bottom: 16px;
}

</style>
